module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Icon/social/twitter_colorfull-3102cc1c56847aea5a877e5bc18f829e.svg";